module.exports = __webpack_public_path__ + "img/dominguez_blanco.b0aa2253.svg";